import { useContext, useState } from "react";
import { DataContext } from "../../utils/contexts";
import { exportPdf } from "utils";
import { ExportExcelCount, ExportPdfCount } from "../../ItemReceived/components";
import { CountList } from "../type";
import { useListExportNew } from "pages/Inventori/Transaction/AddNewItem/utils";
import ModalConfirmExport from "../../components/ModalConfirmExport";

export function ModalExportCount(props: {
    type: "excel" | "pdf" | string,
    setIsOpen: React.Dispatch<React.SetStateAction<{ isOpen: boolean; type: string, activeTab: string | null }>>
}) {
    const [amount, setAmount] = useState<number>(10)
    const { fill, activeColumn } = useContext(DataContext)

    const { data } = useListExportNew("count", {
        start_date: fill.dateFrom,
        end_date: fill.dateTo,
        location_id: fill.location_id,
        count_status: fill.count_status,
        jumlah_item: amount
    })

    const countListData = data.items.filter((item): item is CountList => 'count_id' in (item as CountList))

    return (

        <ModalConfirmExport
            isOpen={true}
            setIsOpen={props.setIsOpen}
            amount={amount}
            setAmount={setAmount}
            title="Item Count"
            type={props.type as "excel" | "pdf"}
            total={data.total_record}
            onExport={() => {
                if (props.type === "excel") {
                    ExportExcelCount({
                        data: countListData,
                        filter: {
                            dateFrom: fill.dateFrom,
                            dateTo: fill.dateTo
                        },
                        module: "INVENTORY",
                        title: "REGISTER COUNT",
                        fileName: "register_count",
                        activeColumns: activeColumn!
                    });
                }

                if (props.type === "pdf") {
                    const documentComponent = (
                        <ExportPdfCount data={countListData} filter={fill} tableActive={activeColumn!} />
                    )
                    exportPdf({ documentComponent, fileName: "register_count" })
                }
            }}
        />
    )
}